import { BrowserSearchEngine } from './common'

const defaultFieldSpecifiers = []

const defaultSyntaxGuideUrl = 'https://api.core.ac.uk/docs/v3'

class CoreEngine extends BrowserSearchEngine {
  constructor (fieldSpecifiers) {
    super('Core')
    this.fieldSpecifiers = fieldSpecifiers || defaultFieldSpecifiers
    this.syntaxGuideUrl = defaultSyntaxGuideUrl
  }

  formulateQuery (query) {
    return 'https://core.ac.uk/search/?q=' + query
  }

  lintQuery (queryGraphData) {
    const m = this.lintFieldSpecifiers(queryGraphData, this.fieldSpecifiers)
    return m ? [m] : []
  }

  getSuggestTermsMetaData () {
    return this.getSuggestTermsDbpediaSettings()
  }
}

export default CoreEngine



// WEBPACK FOOTER //
// ./src/formulate_queries/CoreEngine.js